import { render, staticRenderFns } from "./appUpdateIndex.vue?vue&type=template&id=626cbece"
import script from "./appUpdateIndex.vue?vue&type=script&lang=js"
export * from "./appUpdateIndex.vue?vue&type=script&lang=js"
import style0 from "./appUpdateIndex.vue?vue&type=style&index=0&id=626cbece&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports